import API from './ApiBase';
import {
  CreateMonitoringSessionResult,
  MonitoringSession,
  MonitoringSessionDetail
} from '../types/DeployerControlMonitoring.types';

// The backend's overallScorePercent column is a Prisma Decimal, which
// serializes to JSON as a string (e.g. "87.50"), not a number — even though
// MonitoringSession types it `number | null`. Coerce here, once, at the
// service boundary, so every consumer can trust the type.
const normalizeSession = <T extends MonitoringSession>(session: T): T => ({
  ...session,
  overallScorePercent:
    session.overallScorePercent === null
      ? null
      : Number(session.overallScorePercent)
});

export const createMonitoringSession = async (
  aiSystemId: string
): Promise<CreateMonitoringSessionResult> => {
  const response = await API.post<CreateMonitoringSessionResult>(
    `/ai-systems/${aiSystemId}/monitoring-sessions`,
    undefined,
    // This 403 (wrong entity type) is defense-in-depth — the button that
    // triggers this call is already gated to Deployers in the UI. A toast is
    // enough; don't eject the user from the app for hitting a guard that
    // shouldn't be reachable in the first place.
    { skipAccessDeniedRedirect: true }
  );
  return response.data;
};

export const listMonitoringSessions = async (
  aiSystemId: string
): Promise<MonitoringSession[]> => {
  const response = await API.get<MonitoringSession[]>(
    `/ai-systems/${aiSystemId}/monitoring-sessions`
  );
  return response.data.map(normalizeSession);
};

export const getMonitoringSession = async (
  aiSystemId: string,
  sessionId: string
): Promise<MonitoringSessionDetail> => {
  const response = await API.get<MonitoringSessionDetail>(
    `/ai-systems/${aiSystemId}/monitoring-sessions/${sessionId}`
  );
  return normalizeSession(response.data);
};
